const button = `
    <button id="sign-in-modal-button" type="submit"
            class="custom-button btn btn-primary btn-full mx-auto">
    </button>`;
export default button;